module.exports = __webpack_public_path__ + "static/img/suchunyuan.43ebf12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/suchunyuan.png
// module id = HS88
// module chunks = 0